import { ToolbarEventManagerHelper } from '../../../services/event-managers/toolbar-event-manager.helper';
import { IWorkspaceInstanceModel } from '../../../models/workspace/workspace-instance.model';
import { WorkspaceStore } from '../../../services/stores/workspace.store';
import { VersionHelper } from '../../../services/helpers/version.helper';
import { AfterViewInit, Component } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { CustomViewOption } from '../../../models/timeline/custom-view-option.model';
import { GanttViewType } from '@worktile/gantt';
import { BlueprintStore } from '../../../services/stores/blueprint.store';

@Component({
  selector: 'app-timeline-view-type',
  templateUrl: './timeline-view-type.component.html',
  styleUrl: './timeline-view-type.component.scss',
  standalone: false,
})
export class TimeLineViewTypeComponent extends BaseComponent implements AfterViewInit {
  public nodesNumCount: number = 0;
  public selectedWorkspace: IWorkspaceInstanceModel = {} as IWorkspaceInstanceModel;
  public selectedViewType: GanttViewType = GanttViewType.month;

  public myViews: CustomViewOption[] = [
    { type: GanttViewType.day, label: 'Daily' },
    { type: GanttViewType.week, label: 'Weekly' },
    { type: GanttViewType.month, label: 'Monthly' },
    { type: GanttViewType.quarter, label: 'Quarterly' },
    { type: GanttViewType.year, label: 'Yearly' },
  ];

  constructor(
    private versionHelper: VersionHelper,
    private workspaceStore: WorkspaceStore,
    private toolbarEventManagerHelper: ToolbarEventManagerHelper,
    private blueprintStore: BlueprintStore,
  ) {
    super();
  }

  ngAfterViewInit() {
    this.subscribers.nodeInstanceViewModelList = this.workspaceStore.$nodeInstanceViewModelList.subscribe((nodeList) => {
      if (nodeList) {
        this.nodesNumCount = nodeList.length;
      }
    });
    this.subscribers.workspace = this.workspaceStore.$selectedWorkspaceInstance.subscribe((wsp) => {
      if (wsp) {
        this.selectedWorkspace = wsp;
      }
    });
  }

  public isVersionLowerThan(referenceVersion: string = 'v3.0.6'): boolean {
    const blueprint = this.blueprintStore.getBlueprintByIdFromCache(this.selectedWorkspace?.bluePrintId);
    if (!blueprint?.name || !referenceVersion) {
      return false;
    }
    const versionString = blueprint.name;
    return this.versionHelper.isVersionLowerThan(versionString, referenceVersion);
  }

  public onViewTypeChange(viewType: GanttViewType) {
    this.selectedViewType = viewType;
    this.toolbarEventManagerHelper.TimelineToolbarViewType = viewType;
  }
}
